import { useForm } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useGetOrder } from 'api/orders';
import { useCreatePayment, useCreateDijb } from 'api/payment';
import { WithFormError } from 'components/ui/Form/Form';
import { useModal } from 'contexts/modal-context';

interface IOrderForm {
  terms: boolean;
  privacy: boolean;
  simpleTerms: boolean;
}

const validationSchema = Yup.object()
  .shape({
    terms: Yup.boolean().oneOf([true], 'Kötelező feltétel'),
    privacy: Yup.boolean().oneOf([true], 'Kötelező feltétel'),
    simpleTerms: Yup.boolean().oneOf([true], 'Kötelező feltétel')
  })
  .required();
const validation2Schema = Yup.object()
  .shape({
    terms: Yup.boolean().oneOf([true], 'Kötelező feltétel'),
    privacy: Yup.boolean().oneOf([true], 'Kötelező feltétel')
  })
  .required();

const useOrderPage = () => {
  const { orderRef } = useParams();
  const { data: orderData, isLoading } = useGetOrder(orderRef);
  const { mutate: createPayment } = useCreatePayment();
  const { mutate: createDijb } = useCreateDijb();
  const { openModalWithContent } = useModal();
  const formMethods = useForm<WithFormError<IOrderForm>>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      terms: false,
      privacy: false,
      simpleTerms: false
    }
  });
  const otpResponse = localStorage.getItem('otp');

  const onsubmit = () => {
    if (orderRef) {
      createPayment(
        { orderRef },
        {
          onSuccess: (response) => {
            window.location.href = response.paymentUrl;
          }
        }
      );
    }
  };

  const navigate = useNavigate();

  // 2023-10-05 pjung PARWEB-10 Díjbekérő + validálás
  // @see https://dev.to/feijens/react-hook-form-multiple-yup-validation-schemas-5a22
  const handleDijb = async () => {
    const data = formMethods.getValues();

    // try catch block for yup validate function. abortEarly: false so it returns all errors on our form.
    try {
      await validation2Schema.validate(data, { abortEarly: false });
    } catch (error) {
      // loop over all errors and setError to use them in react-hook-form
      (error as Yup.ValidationError).inner?.map(({ type, path, errors }) =>
        formMethods.setError(path as keyof IOrderForm, {
          type,
          message: errors[0]
        })
      );
      return;
    }
    // if passes, data is valid
    if (orderRef) {
      createDijb(
        { orderRef },
        {
          onSuccess: (response) => {
            localStorage.setItem('otp', '{"e":"DIJB"}');
            navigate(`/orders/${orderData?.orderId}/status`);
          }
        }
      );
    }
  };

  const handleGoBack = () => {
    if (orderData) {
      window.location.href = orderData?.backUrl;
    }
  };

  const handleAcceptCheckbox = (type: keyof IOrderForm) => {
    formMethods.setValue(type, true);
  };

  return {
    orderData,
    isLoading,
    formMethods,
    onsubmit,
    otpResponse: otpResponse ? JSON.parse(otpResponse) : undefined,
    handleGoBack,
    handleDijb,
    openModalWithContent,
    handleAcceptCheckbox
  };
};

export default useOrderPage;
